export default __webpack_public_path__ + "static/media/loss_img.c5663f5e.png";